<template>
  <div>
    <!-- TABS PARA MOSTRAR LOS EXPEDIENTES -->
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab key="CA">
        <v-icon left> mdi-account-box-outline </v-icon>
        Categoria - A
      </v-tab>
      <v-tab key="CB1">
        <v-icon left> mdi-account-box-outline </v-icon>
        Categoria - B1
      </v-tab>
      <v-tab key="CB2">
        <v-icon left> mdi-account-box-outline </v-icon>
        Categoria - B2
      </v-tab>
      <!-- TAB CATEGORIA A -->
      <v-tab-item>
        <v-card :elevation="1" class="v-sheet theme--light br-0">
          <v-card-title>
            <v-row class="col-md-12">
              <v-col cols="12" sm="12" md="6"> Expedientes </v-col>
              <v-col cols="12" sm="12" md="6">
                <!--v-btn
              color=""
              dark
              class="mb-2 float-right blue-grey darken-2"
              :to="{name: 'expedientes-ingreso'}"
            >
              Registrar Expediente
            </!--v-btn-->
              </v-col>
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
              <v-divider></v-divider>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-0 pr-0">
            <v-data-table
              class="elevation-0"
              :headers="headers"
              :items="itemsA"
              :search="filtro"
              :loading="tableLoading"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                'items-per-page-text': 'Registros por página',
                pageText: '{0}-{1} de {2}',
              }"
            >
              <template v-slot:top>
                <!-- v-container, v-col and v-row are just for decoration purposes. -->
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-text-field
                        autocomplete="off"
                        class="required"
                        dense
                        filled
                        color="blue-grey lighten-2"
                        v-model="filtro"
                        label="Número, nombre del proyecto, descripción..."
                        maxlength="200"
                      >
                        <v-icon slot="append" color="black">
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-select
                        v-model="estadoProyecto"
                        :items="estadosProyecto"
                        :loading="false"
                        dense
                        filled
                        label="Estado"
                        :no-data-text="'No existen estados registrados'"
                        menu-props="auto"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                      <v-btn
                        class="ma-0 white--text d-none"
                        medium
                        color="light-blue darken-2"
                      >
                        <v-icon left>mdi-magnify</v-icon> Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>
                    <v-tooltip
                      right
                      color="white"
                      v-if="item.ampliaciones_recibidas > 0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="warning" dark v-bind="attrs" v-on="on">
                          fas fa-info-circle icon-md
                        </v-icon>
                      </template>
                      <span class="black--text"
                        >Tiene Ampliaciones Legales recibidas.</span
                      >
                    </v-tooltip>
                    {{ item.no_Expediente }}
                  </td>
                  <td>{{ item.nombre_Proyecto }}</td>
                  <td>
                    <v-chip
                      class="ma-2 font-weight-medium"
                      label
                      :color="
                        item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-4'
                          : item.estadosExpedienteId === 10
                          ? 'cyan lighten-3'
                          : item.estadosExpedienteId === 11
                          ? 'pink lighten-4'
                          : 'pink lighten-4'
                      "
                      :text-color="
                        item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-1'
                          : item.estadosExpedienteId === 10
                          ? 'light-blue darken-4'
                          : item.estadosExpedienteId === 11
                          ? 'pink darken-1'
                          : 'pink darken-1'
                      "
                      small
                    >
                      {{ item.estadoExpediente }}
                      <template
                        v-if="
                          item.estadosExpedienteId !== 7 &&
                          item.estadosExpedienteId !== 10 &&
                          item.estadosExpedienteId !== 11
                        "
                      >
                      </template>
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        iniciarAnalisis(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> VER EXPEDIENTE
                    </v-btn>
                    <!--                    <v-btn-->
                    <!--                      v-if="-->
                    <!--                        item.resolucion === 0 && item.estadosExpedienteId === 13-->
                    <!--                      "-->
                    <!--                      class="ma-2 btn-bg-light blue&#45;&#45;text darken-4&#45;&#45;text font-weight-medium text-capitalize"-->
                    <!--                      small-->
                    <!--                      color="blue lighten-5"-->
                    <!--                      @click="openInNewTab(item.id)"-->
                    <!--                    >-->
                    <!--                      <v-icon left>fas fa-file-signature</v-icon> CREAR-->
                    <!--                      RESOLUCIÓN-->
                    <!--                    </v-btn>-->
                    <v-btn
                      v-if="
                        item.dictamenCargado > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(item.dictamenCargadoRuta)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Dictamen
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 &&
                        item.resolucionCargada === 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue&#45;&#45;text darken-4&#45;&#45;text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        agregarDictamen(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Generar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(item.pathResolucion)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucionCargada > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(
                          item.pathResolucionCargado
                        )
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución Cargada
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29) &&
                        item.principal === 1
                      "
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="mostrarModalCargaDocumento(item.id)"
                    >
                      <v-icon left>mdi-cloud-upload</v-icon>
                      Cargar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucionCargada > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="enviarDirector(item.id, item.nombre_Proyecto)"
                    >
                      <v-icon left>fas fa-edit</v-icon>
                      Enviar a JefeDCA
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <!-- <template v-slot:html>
            {{ code4.html }}
          </template>
          <template v-slot:js>
            {{ code4.js }}
          </template> -->
        </v-card>
      </v-tab-item>
      <!-- TAB CATEGORIA B1 -->
      <v-tab-item>
        <v-card :elevation="1" class="v-sheet theme--light br-0">
          <v-card-title>
            <v-row class="col-md-12">
              <v-col cols="12" sm="12" md="6"> Expedientes </v-col>
              <v-col cols="12" sm="12" md="6">
                <!--v-btn
              color=""
              dark
              class="mb-2 float-right blue-grey darken-2"
              :to="{name: 'expedientes-ingreso'}"
            >
              Registrar Expediente
            </!--v-btn-->
              </v-col>
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
              <v-divider></v-divider>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-0 pr-0">
            <v-data-table
              class="elevation-0"
              :headers="headers"
              :items="itemsB1"
              :search="filtro"
              :loading="tableLoading"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                'items-per-page-text': 'Registros por página',
                pageText: '{0}-{1} de {2}',
              }"
            >
              <template v-slot:top>
                <!-- v-container, v-col and v-row are just for decoration purposes. -->
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-text-field
                        autocomplete="off"
                        class="required"
                        dense
                        filled
                        color="blue-grey lighten-2"
                        v-model="filtro"
                        label="Número, nombre del proyecto, descripción..."
                        maxlength="200"
                      >
                        <v-icon slot="append" color="black">
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-select
                        v-model="estadoProyecto"
                        :items="estadosProyecto"
                        :loading="false"
                        dense
                        filled
                        label="Estado"
                        :no-data-text="'No existen estados registrados'"
                        menu-props="auto"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                      <v-btn
                        class="ma-0 white--text d-none"
                        medium
                        color="light-blue darken-2"
                      >
                        <v-icon left>mdi-magnify</v-icon> Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>
                    <v-tooltip
                      right
                      color="white"
                      v-if="item.ampliaciones_recibidas > 0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="warning" dark v-bind="attrs" v-on="on">
                          fas fa-info-circle icon-md
                        </v-icon>
                      </template>
                      <span class="black--text"
                        >Tiene Ampliaciones recibidas.</span
                      >
                    </v-tooltip>
                    {{ item.no_Expediente }}
                  </td>
                  <td>{{ item.nombre_Proyecto }}</td>
                  <!-- <td>
                    {{ item.descripcion_Proyecto }}
                  </td> -->
                  <td>
                    <v-chip
                      class="ma-2 font-weight-medium"
                      label
                      :color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-4'
                          : item.estadosExpedienteId === 2
                          ? 'cyan lighten-4'
                          : item.estadosExpedienteId === 3
                          ? 'amber'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-4'
                          : 'pink lighten-4'
                      "
                      :text-color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-1'
                          : item.estadosExpedienteId === 2
                          ? 'cyan darken-1'
                          : item.estadosExpedienteId === 3
                          ? 'deep-orange darken-4'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-1'
                          : 'pink darken-1'
                      "
                      small
                    >
                      {{ item.estadoExpediente }}
                      <template
                        v-if="
                          item.estadosExpedienteId !== 7 &&
                          item.estadosExpedienteId !== 10 &&
                          item.estadosExpedienteId !== 11
                        "
                      >
                      </template>
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        iniciarAnalisis(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> VER EXPEDIENTE
                    </v-btn>
                    <v-btn
                      v-if="
                        item.dictamenCargado > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(item.dictamenCargadoRuta)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Dictamen
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 &&
                        item.resolucionCargada === 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue&#45;&#45;text darken-4&#45;&#45;text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        agregarDictamen(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Generar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(item.pathResolucion)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucionCargada > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(
                          item.pathResolucionCargado
                        )
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución Cargada
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29) &&
                        item.principal === 1
                      "
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="mostrarModalCargaDocumento(item.id)"
                    >
                      <v-icon left>mdi-cloud-upload</v-icon>
                      Cargar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucionCargada > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="enviarDirector(item.id, item.nombre_Proyecto)"
                    >
                      <v-icon left>fas fa-edit</v-icon>
                      Enviar a JefeDCA
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <!-- <template v-slot:html>
            {{ code4.html }}
          </template>
          <template v-slot:js>
            {{ code4.js }}
          </template> -->
        </v-card>
      </v-tab-item>
      <!-- TAB CATEGORIA B2 -->
      <v-tab-item>
        <v-card :elevation="1" class="v-sheet theme--light br-0">
          <v-card-title>
            <v-row class="col-md-12">
              <v-col cols="12" sm="12" md="6"> Expedientes </v-col>
            </v-row>
            <v-row class="col-md-12 m-0 p-0">
              <v-divider></v-divider>
            </v-row>
          </v-card-title>
          <v-card-text class="pl-0 pr-0">
            <v-data-table
              class="elevation-0"
              :headers="headers"
              :items="itemsB2"
              :search="filtro"
              :loading="tableLoading"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                'items-per-page-text': 'Registros por página',
                pageText: '{0}-{1} de {2}',
              }"
            >
              <template v-slot:top>
                <!-- v-container, v-col and v-row are just for decoration purposes. -->
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-text-field
                        autocomplete="off"
                        class="required"
                        dense
                        filled
                        color="blue-grey lighten-2"
                        v-model="filtro"
                        label="Número, nombre del proyecto, descripción..."
                        maxlength="200"
                      >
                        <v-icon slot="append" color="black">
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-0 pb-0">
                      <v-select
                        v-model="estadoProyecto"
                        :items="estadosProyecto"
                        :loading="false"
                        dense
                        filled
                        label="Estado"
                        :no-data-text="'No existen estados registrados'"
                        menu-props="auto"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="2" md="2" sm="12" xs="6" class="d-none">
                      <v-btn
                        class="ma-0 white--text d-none"
                        medium
                        color="light-blue darken-2"
                      >
                        <v-icon left>mdi-magnify</v-icon> Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>
                    <v-tooltip
                      right
                      color="white"
                      v-if="item.ampliaciones_recibidas > 0"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="warning" dark v-bind="attrs" v-on="on">
                          fas fa-info-circle icon-md
                        </v-icon>
                      </template>
                      <span class="black--text"
                        >Tiene Ampliaciones recibidas.</span
                      >
                    </v-tooltip>
                    {{ item.no_Expediente }}
                  </td>
                  <td>{{ item.nombre_Proyecto }}</td>
                  <!-- <td>
                    {{ item.descripcion_Proyecto }}
                  </td> -->
                  <td>
                    <v-chip
                      class="ma-2 font-weight-medium"
                      label
                      :color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-4'
                          : item.estadosExpedienteId === 2
                          ? 'cyan lighten-4'
                          : item.estadosExpedienteId === 3
                          ? 'amber'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-4'
                          : 'pink lighten-4'
                      "
                      :text-color="
                        item.estadosExpedienteId === 1
                          ? 'blue lighten-1'
                          : item.estadosExpedienteId === 2
                          ? 'cyan darken-1'
                          : item.estadosExpedienteId === 3
                          ? 'deep-orange darken-4'
                          : item.estadosExpedienteId === 7
                          ? 'deep-orange lighten-1'
                          : 'pink darken-1'
                      "
                      small
                    >
                      {{ item.estadoExpediente }}
                      <template
                        v-if="
                          item.estadosExpedienteId !== 7 &&
                          item.estadosExpedienteId !== 10 &&
                          item.estadosExpedienteId !== 11
                        "
                      >
                      </template>
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        iniciarAnalisis(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-edit</v-icon> VER EXPEDIENTE
                    </v-btn>
                    <v-btn
                      v-if="
                        item.dictamenCargado > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(item.dictamenCargadoRuta)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Dictamen
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion === 0 &&
                        item.resolucionCargada === 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue&#45;&#45;text darken-4&#45;&#45;text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        agregarDictamen(
                          item.id,
                          item.nombre_Proyecto,
                          item.estadosExpedienteId
                        )
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Generar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(item.pathResolucion)
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucionCargada > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="
                        ObtenerResolucionByExpediente(
                          item.pathResolucionCargado
                        )
                      "
                    >
                      <v-icon left>fas fa-file-signature</v-icon>
                      Visualizar Resolución Cargada
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucion > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue-grey--text lighten-2--text font-weight-medium text-capitalize"
                      small
                      depressed
                      color="blue-grey lighten-5"
                      @click="mostrarModalCargaDocumento(item.id)"
                    >
                      <v-icon left>mdi-cloud-upload</v-icon>
                      Cargar Resolución
                    </v-btn>
                    <v-btn
                      v-if="
                        item.resolucionCargada > 0 &&
                        (item.estadosExpedienteId === 13 ||
                          item.estadosExpedienteId === 29)
                      "
                      class="ma-2 btn-bg-light blue--text darken-4--text font-weight-medium text-capitalize"
                      small
                      color="blue lighten-5"
                      @click="enviarDirector(item.id, item.nombre_Proyecto)"
                    >
                      <v-icon left>fas fa-edit</v-icon>
                      Enviar a JefeDCA
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <!--begin:: DIALOG PARA INICIAR EL ANALISIS -->
    <v-dialog
      v-model="dialogAnalisis"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Análisis del Expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogAnalisis = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>¿Desea iniciar el análisis del siguiente expediente?</h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogAnalisis = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(13)"
            :loading="btnEnvioAnalisis"
          >
            Sí, iniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--begin:: dialog envío expediente -->
    <!--begin:: crear dictamen -->
    <v-dialog
      v-model="dialogCrearDictamen"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Generar Resolución

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="ddlLoading"
            @click="dialogCrearDictamen = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>
                ¿Está seguro que desea crear la Resolución del siguiente
                expediente?
              </h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>

          <!-- Spinner visible mientras ddlLoading está en true -->
          <v-row v-if="ddlLoading" class="justify-center mt-4">
            <v-col cols="12" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogCrearDictamen = false"
            :disabled="ddlLoading"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="registrarItemDictamen"
            :loading="ddlLoading"
            :disabled="ddlLoading"
          >
            Crear Resolución
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--begin:: DIALOG PARA INICIAR EL ANALISIS -->
    <v-dialog
      v-model="dialogAnalisis"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Análisis del Expediente

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogAnalisis = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>¿Desea iniciar el análisis del siguiente expediente?</h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogAnalisis = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(13)"
            :loading="btnEnvioAnalisis"
          >
            Sí, iniciar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--begin:: DIALOG SOLICITUD DE VISTA PÚBLICA -->
    <v-dialog
      v-model="dialogSolicitud"
      width="800"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Solicitud Vista Pública

          <v-spacer></v-spacer>
          <v-btn icon @click="dialogSolicitud = false" class="float-right">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Fecha de la Solicitud</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.fecha
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Fotocopia Dpi</v-list-item-title
                  >
                  <v-btn
                    small
                    block
                    class="blue--text lighten-2--text text-capitalize"
                    color="blue lighten-5"
                    @click="descargarArchivo(solicitud.path)"
                  >
                    <v-icon left>mdi-file-download-outline</v-icon>
                    Descargar
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Expediente</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.no_Expediente
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Nombre del Proyecto</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.nombre_Proyecto
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Nombre del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.nombre
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Dpi del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.dpi
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >No. de Teléfono del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.no_Telefono
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col md="6" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Correo del Solicitante</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="12" sm="12" xs="12" class="pt-1 pb-1">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase"
                    >Motivo de la Solicitud</v-list-item-title
                  >
                  <v-list-item-subtitle class="text-subtitle-1">{{
                    solicitud.motivo
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="red--text"
            dark
            color="red lighten-4"
            :loading="btnRegistroRequisitoLoading"
            @click="cambiarEstadoSolicitud(solicitud.id, 2)"
          >
            <v-icon left>fas fa-user-times</v-icon>Rechazar
          </v-btn>
          <!--:disabled="!validDocForm" type="submit"-->
          <v-btn
            class="green--text"
            dark
            color="teal lighten-5"
            :loading="btnRegistroRequisitoLoading"
            @click="cambiarEstadoSolicitud(solicitud.id, 1)"
          >
            <v-icon left> fas fa-user-check</v-icon>Aprobar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG PARA PODER CARGAR LA RESOLUCIÓN -->
    <v-dialog
      v-model="dialogCargaDocumento"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Cargar Resolución

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnCargaDocLoading"
            @click="dialogCargaDocumento = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="formDoc"
            v-on:submit.prevent="cargarArchivo"
            v-model="validFormDocumento"
          >
            <v-row>
              <v-col cols="12" md="12" sm="12" class="pt-0 mt-4 pb-0 mb-0">
                <v-subheader class="text-h6 text-uppercase">
                  {{ documentoSeleccionado }}
                </v-subheader>
              </v-col>
              <v-col cols="12" md="12" sm="12" class="pt-0 mt-4 pb-0 mb-0">
                <template>
                  <v-file-input
                    id="docFile"
                    dense
                    filled
                    placeholder="Seleccionar archivo .pdf"
                    accept=".pdf"
                    append-icon="far fa-file-pdf"
                    prepend-icon=""
                    @change="onFileChange"
                    :rules="[fileRequired('documento')]"
                    :show-size="1000"
                    ref="docFile"
                    class="required"
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip v-if="index < 2" small label color="primary">
                        {{ text }}
                      </v-chip>
                      <span
                        v-else-if="index === 2"
                        class="text-overline grey--text text--darken-3 mx-2"
                      >
                        +{{ files.length - 2 }} archivo(s)
                      </span>
                    </template>
                  </v-file-input>
                </template>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-btn
                  class="float-right m-1"
                  color="indigo"
                  dark
                  type="submit"
                  :disabled="!validFormDocumento || btnCargaDocLoading"
                >
                  Cargar Resolución
                </v-btn>
                <v-btn
                  class="float-right white--text m-1"
                  color="blue-grey darken-2"
                  @click="dialogCargaDocumento = false"
                  :disabled="btnCargaDocLoading"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-row v-if="btnCargaDocLoading" class="justify-center mt-4">
            <v-col cols="12" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- FIN DIALOG PARA PODER CARGAR LA RESOLUCIÓN -->
    <!--begin:: DIALOG ENVIO DE EXPEDIENTE A DIRECTOR -->
    <v-dialog
      v-model="dialogEnviar"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Enviar a JefeDCA

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnEnvioAnalisis"
            @click="dialogEnviar = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12">
              <h3>
                ¿Está seguro que desea enviar al director el siguiente
                expediente?
              </h3>
              {{ proyectoSeleccionado }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="dialogEnviar = false"
            :disabled="btnEnvioAnalisis"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue-grey darken-2"
            text
            @click="enviarExpediente(14)"
            :loading="btnEnvioAnalisis"
          >
            Sí, enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOGO PARA REGISTRAR LAS  OPOSICIONES-->
    <v-dialog
      v-model="modalVisible.Oposicion"
      width="600"
      transition="scroll-y-transition"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          Registro Oposición

          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="btnregist"
            @click="modalVisible.Oposicion = false"
            class="float-right"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="formOP"
            v-on:submit.prevent="
              registrarOposicionItem(modalVisible.expediente)
            "
            v-model="validBoletaForm"
          >
            <!-- <v-row>
              <v-col cols="12" md="12" class="pt-4 pb-0">
                <v-text-field
                  autocomplete="off"
                  class=""
                  dense
                  filled
                  color="blue-grey darken-2"
                  v-model="datosOposicion.descripcion"
                  label="Descripcion"
                  :rules="[
                    required('descripcion'),
                    maxLengthForm100('descripcion'),
                  ]"
                  maxlength="100"
                ></v-text-field>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12">
                <!--:disabled="!validDocForm" type="submit"-->
                <v-btn
                  color="primary"
                  class="mb-2 float-right"
                  type="submit"
                  :disabled="!validBoletaForm"
                  :loading="btnRegistroOposicion"
                  @click="registrarOposicionItem(modalVisible.expediente)"
                >
                  Guardar
                </v-btn>
              </v-col>
            </v-row>
            <!-- Acá va la parte, donde se muestran la lista de registros -->
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- FIN DEL  DIALOGO PARA REGISTRAR LAS OPOSICIONES-->
    <!--Dialog loader -->
    <DialogLoader
      :dialogVisible="dialogLoaderVisible"
      :text="dialogLoaderText"
      transition="scroll-y-transition"
    ></DialogLoader>
    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DialogLoader from "@/view/content/DialogLoader";
import SnackAlert from "@/view/content/alerts/SnackAlert.vue";
import JwtService from "@/core/services/jwt.service";
import validations from "@/core/untils/validations.js";
import {
  ACTUALIZAR_ESTADO_EXPEDIENTE,
  OBTENER_EXPEDIENTES_BY_CATEGORIA3,
} from "@/core/services/store/expedientes/expedientes.module";
// import { OBTENER_EXPEDIENTES_BY_CATEGORIA_USER } from "@/core/services/store/expedientes/expedientes.module";
import { OBTENER_DICTAMENES } from "@/core/services/store/dictamenes/dictamenes.module";
import {
  //REGISTRAR_RESOLUCION_EXPEDIENTE,
  OBTENER_RESOLUCIONES_EXPEDIENTE,
  OBTENER_DICTAMEN_EXPEDIENTE,
  //ACTUALIZAR_RESOLUCION_EXPEDIENTE,
} from "@/core/services/store/resoluciones/expedienteresolucion.module";
import { OBTENER_PATH_RESOLUCION_PLANTILLA } from "@/core/services/store/expedientes/dictamenPlantilla/resolucionPlantilla.module";
import { CARGAR_ARCHIVO } from "@/core/services/store/cargaarchivo.module";
import { OBTENER_OPINIONES_TECNICAS } from "@/core/services/store/opinionesTecnicas/opinionestecnicas.module";
import {
  CAMBIAR_ESTADO_EXPEDIENTE_RESOLUCION,
  OBTENER_DOCUMENTO_RESOLUCION,
} from "@/core/services/store/resoluciones/resolucion.module";
import { REGISTRAR_OPOSICION } from "@/core/services/store/oposiciones/oposiciones.module";
import modal from "@/view/pages/vue-bootstrap/Modal.vue";
import Vue from "vue";
/*
import {OBTENER_CONTACTOS, REGISTRAR_CONTACTO} from "@/core/services/store/contactos/contacto.module";
import classSet from '../../../../assets/plugins/formvalidation/src/js/utils/classSet';
*/

export default {
  name: "AdminExpedientes",
  data() {
    return {
      tab: null,
      dialogResolucion: false,
      documentUrlResolucion: "",
      url: process.env.VUE_APP_API_URL,
      tabContactosDisabled: true,
      tableLoading: false,
      validForm: false,
      dialogEnvio: false,
      ddlLoading: false,
      btnEnvioLoading: false,
      btnRegistroContactoLoading: false,
      contactos: [],
      tableContactosLoading: false,
      ddRolesLoading: false,
      dialogRegistro: false,
      dialogLoaderVisible: false,
      dialogLoaderText: "",
      switchItemEstado: true,
      proyectoSeleccionado: "",
      filtro: "",
      tipoContactoSeleccionado: {},
      dialog: false,
      dialogTitle: "Registrar nuevo proyecto",
      accion: 1,
      btnRegistroText: "Guardar",
      btnRegistroLoading: false,
      estadoProyecto: "",
      items: [],
      cargos: [],
      estadosProyecto: [
        { text: "Todos", value: null },
        { value: 7, text: "Pre-Análisis" },
        { value: 12, text: "Pre-Resolución" },
        { value: 13, text: "Resolución" },
        // { value: 3, text: "Ampliacion" },
      ],
      ...validations,
      tableALoading: false,
      itemsA: [],
      tableB1Loading: false,
      itemsB1: [],
      tableB2Loading: false,
      itemsB2: [],
      dialogAnalisis: false,
      btnEnvioAnalisis: false,
      datosEnvioItem: {
        id: 0,
        estadoExpedienteId: 0,
        usuario: "admin",
      },
      datosEnvioEmail: {
        id: 0,
        estadoSolicitudId: 0,
        usuario_Actualizacion: "admin",
      },
      datosItemDictamen: {
        expedienteId: 0,
        tipo: 0,
        usuario: "",
        pathPdf: "",
      },
      solicitudes: [],
      filtroSolicitudes: "",
      tableSolicitudesLoading: false,
      dialogSolicitud: false,
      solicitud: {},
      dialogDictamen: false,
      validFormDictamen: false,
      btnRegistroDictamenLoading: false,
      datosItemResolucion: {
        id: 0,
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        resolucionId: 1,
        expedienteId: 0,
        pathWord: "",
        tipoAprobacion: 0,
      },
      dictamenes: [],
      itemsDictamen: [],
      tableDictamenLoading: false,
      ddlDictamenesLoading: false,
      dialogCrearDictamen: false,

      btnCargaDocLoading: false,
      dialogCargaDocumento: false,
      validFormDocumento: false,
      documentoSeleccionado: "",
      archivoCargado: false,
      archivo: [],
      expedienteId: 0,
      resolucionExpedienteId: 0,
      nombrePlantilla: "",
      dialogEnviar: false,
      dialogOpinionesTecnicas: false,
      tableOPLoading: false,
      opinionesTecnicas: [],
      filtroOP: "",
      datosExpediente: {
        id_Expediente: 0,
        estado_Id: 0,
        usuario: "string",
      },
      datosOposicion: {
        descripcion: "",
        expedienteid: 0,
        usuario_creacion: JwtService.getUser(),
      },
      modalVisible: {
        Oposicion: false,
        expediente: 0,
      },
    };
  },
  components: {
    DialogLoader,
    SnackAlert,
  },
  methods: {
    openInNewTab(id) {
      if (id) {
        const url = this.$router.resolve({
          name: "vista-dictamen",
          params: { id: id },
        }).href;
        window.open(url, "_blank");
      }
    },
    // Obtener los items op
    async obtenerOpinionesTecnicas(id) {
      this.opinionesTecnicas = [];
      this.tableOPLoading = true;

      this.$store
        .dispatch(OBTENER_OPINIONES_TECNICAS, id)
        .then((res) => {
          if (res.status === 200) {
            this.opinionesTecnicas =
              this.$store.state.opinionestecnicas.opinionesTecnicas;
          }
          this.tableOPLoading = false;
        })
        .catch(() => {
          this.tableOPLoading = false;
        });
    },
    modalOpososicion(Id) {
      this.modalOpososicion = true;
      this.datosOposicion.expedienteId = Id;
    },
    openModal(modalName, id) {
      this.modalVisible[modalName] = true;
      this.modalVisible.expediente = id;
    },
    modalOpinionTecnica(Id) {
      this.obtenerOpinionesTecnicas(Id);
      this.dialogOpinionesTecnicas = true;
    },
    resetFormDictamen() {
      this.datosItemResolucion = {
        id: 0,
        usuario_Creacion: "admin",
        fecha_Creacion: "2022-07-14",
        estadosId: 1,
        resolucionId: 1,
        expedienteId: 0,
        tipoAprobacion: 0,
      };
    },
    agregarDictamen(id, nombreProyecto, estado) {
      this.estadoExpediente = estado;
      this.proyectoSeleccionado = nombreProyecto;
      this.datosItemDictamen.expedienteId = id;
      this.expedienteSeleccionado = id;
      this.dialogCrearDictamen = true;
    },

    async ObtenerResolucionByExpediente(path) {
      let newPath = path.replace(/\\/g, "/");
      const baseUrl = process.env.VUE_APP_INTERFACE;
      window.open(baseUrl + newPath, "_blank");
    },
    //Mostrar el dialogo para la suspension
    enviarDirector(id, nombreProyecto) {
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.id = id;
      this.proyectoSeleccionado = nombreProyecto;
      this.dialogEnviar = true;
      this.dialogLoaderVisible = false;
    },
    verSolicitud(id) {
      this.obtenerSolicitud(id);
    },
    filtroEstado(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.estadoProyecto.value) {
        return true;
      }
      //console.log(value);
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value === this.estadoProyecto.text;
    },
    //Mostrar el dialogo para la suspension
    iniciarAnalisis(id, nombreProyecto, estadosExpedienteId) {
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.id = id;
      this.proyectoSeleccionado = nombreProyecto;

      if (estadosExpedienteId === 28 || estadosExpedienteId === 12) {
        this.dialogAnalisis = true;
        /*this.$router.push({
          name: "vista-procurador",
          params: { id: this.datosEnvioItem.id },
        });*/
      } else if (
        estadosExpedienteId === 13 ||
        estadosExpedienteId === 7 ||
        estadosExpedienteId === 10 ||
        estadosExpedienteId === 11
      ) {
        this.$router.push({
          name: "vista-procurador",
          params: { id: this.datosEnvioItem.id },
        });
      }
      this.dialogLoaderVisible = false;
    },
    // Obtener los items
    async obtenerDictamenes() {
      this.dictamenes = [];
      this.ddlDictamenesLoading = true;

      this.$store
        .dispatch(OBTENER_DICTAMENES, 1)
        .then((res) => {
          if (res.status === 200) {
            this.dictamenes = this.$store.state.dictamenes.dictamenes;
          }
          //console.log(this.solicitudes);
          this.ddlDictamenesLoading = false;
        })
        .catch(() => {
          this.ddlDictamenesLoading = false;
        });
    },
    // Obtener los items expediente dictamen
    async obtenerExpedienteDictamenes(id) {
      this.itemsDictamen = [];
      this.tableDictamenLoading = true;

      this.$store
        .dispatch(OBTENER_RESOLUCIONES_EXPEDIENTE, id)
        .then((res) => {
          if (res.status === 200) {
            this.itemsDictamen =
              this.$store.state.expedienteresolucion.resolucionesExpediente;
            this.dialogDictamen = true;
            this.expedienteId = id;
            //console.log(this.expedienteId);
          }
          //console.log(this.solicitudes);
          this.tableDictamenLoading = false;
        })
        .catch(() => {
          this.tableDictamenLoading = false;
        });
    },
    obtenerDatosItem(Id) {
      this.dialogLoaderVisible = true;
      this.dialogLoaderText = "Obteniendo información...";
      this.$store
        .dispatch(OBTENER_DICTAMEN_EXPEDIENTE, Id)
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.datosItemResolucion =
              this.$store.state.expedientedictamen.dictamenExpediente;
            this.accion = 2;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`
            );
          }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error inesperado, por favor, póngase en contacto con el administrador del sistema.`
          );
          this.dialogLoaderVisible = false;
        });
    },
    /// Obtener los items
    async obtenerItemsA() {
      this.itemsA = [];
      this.tableALoading = true;

      const userId = JwtService.getUserId();

      this.$store
        .dispatch(OBTENER_EXPEDIENTES_BY_CATEGORIA3, {
          categoriaId: 1,
          tipoBandeja: 10,
          id: userId, // Pasar el nuevo parámetro id
        })
        .then((res) => {
          if (res.status === 200) {
            this.itemsA = this.$store.state.expedientes.expedientes;
          }
          //console.log(this.itemsA);
          this.tableALoading = false;
        })
        .catch(() => {
          this.tableALoading = false;
        });
    },
    /// Obtener los items
    async obtenerItemsB1() {
      this.itemsB1 = [];
      this.tableB1Loading = true;
      this.$store
      const userId = JwtService.getUserId();

      this.$store
          .dispatch(OBTENER_EXPEDIENTES_BY_CATEGORIA3, {
            categoriaId: 2,
            tipoBandeja: 10,
            id: userId, // Pasar el nuevo parámetro id
        })
        .then((res) => {
          if (res.status === 200) {
            this.itemsB1 = this.$store.state.expedientes.expedientes;
          }
          //console.log(this.items);
          this.tableB1Loading = false;
        })
        .catch(() => {
          this.tableB1Loading = false;
        });
    },
    /// Obtener los items
    async obtenerItemsB2() {
      this.itemsB2 = [];
      this.tableB2Loading = true;
      const userId = JwtService.getUserId();

      this.$store
          .dispatch(OBTENER_EXPEDIENTES_BY_CATEGORIA3, {
            categoriaId: 3,
            tipoBandeja: 10,
            id: userId, // Pasar el nuevo parámetro id
        })
        .then((res) => {
          if (res.status === 200) {
            this.itemsB2 = this.$store.state.expedientes.expedientes;
          }
          //console.log(this.items);
          this.tableB2Loading = false;
        })
        .catch(() => {
          this.tableB2Loading = false;
        });
    },
    //Enviar el expediente
    async enviarExpediente(estado) {
      //10 = analisis, 12 = procurador
      this.dialogLoaderVisible = true;
      this.datosEnvioItem.estadoExpedienteId = estado;
      await this.$store
        .dispatch(ACTUALIZAR_ESTADO_EXPEDIENTE, this.datosEnvioItem)
        .then((res) => {
          //console.log(res);
          if (res.status === 200) {
            this.expedienteRegistrado = 1;
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            // if (estado === 10) {
            //   this.$router.push({
            //     name: "vista-asesor",
            //     params: { id: this.datosEnvioItem.id },
            //   });
            // } else if (estado === 12) {
            this.obtenerItemsA();
            this.obtenerItemsB1();
            this.obtenerItemsB2();
            //}
            this.dialogEnviar = false;
            this.dialogAnalisis = false;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro.`
          );
        });
    },
    async registrarOposicionItem(id) {
      // this.dictamenes = [];
      this.dialogOposicionConsideraciones = true;
      this.btnRegistroOposicion = true;
      this.datosOposicion.expedienteId = id;
      this.datosOposicion.usuario_creacion = JwtService.getUser();

      this.$store
        .dispatch(REGISTRAR_OPOSICION, this.datosOposicion)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogOposicionConsideraciones = false;
          this.btnRegistroOposicion = false;
        })
        .catch(() => {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `Ha ocurrido un error durante el registro de la Oposición`
          );
          this.dialogOposicionConsideraciones = false;
          this.btnRegistroOposicion = false;
        });
    },
    // Método para obtener el documento de la resolución
    async ObtenerDocumentoResolucion(Id) {
      this.expedienteId = Id;
      this.dialogLoaderVisible = true;
      this.$store
        .dispatch(OBTENER_DOCUMENTO_RESOLUCION, Id)
        .then((res) => {
          if (res.status === 200) {
            this.dialogResolucion = true;
            this.documentUrlResolucion =
              this.$store.state.resolucion.resolucion;
            // this.obtenerExpedienteDictamenes(this.expedienteId);
          }
          this.dialogLoaderVisible = false;
          //console.log(this.items);
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
        });
    },
    //Registro de categorias
    async registrarItemDictamen() {
      // Mostrar loading
      this.ddlLoading = true;
      this.solicitud = [];
      this.datosItemDictamen.usuario = JwtService.getUserId();

      try {
        const res = await Vue.axios.post(
          `${this.url}/api/GenerarDocumento/createResolucionAMI`,
          this.datosItemDictamen
        );

        if (res.data.status === 200) {
          this.solicitud = res.data.data;
          this.$refs.snackalert.SnackbarShow(
            "success",
            "Alerta",
            res.data.message
          );
          this.dialogCrearDictamen = false;
          this.obtenerItemsA();
          this.obtenerItemsB1();
          this.obtenerItemsB2();
        } else {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            res.data.message || "Ocurrió un problema al crear la resolución."
          );
        }
      } catch (error) {
        if (error.response && error.response.status === 500) {
          this.$refs.snackalert.SnackbarShow(
            "error",
            "Error",
            "Ocurrió un error en el servidor, intente nuevamente."
          );
        } else {
          this.$refs.snackalert.SnackbarShow(
            "error",
            "Error",
            "Ocurrió un error inesperado al procesar la solicitud."
          );
        }
      } finally {
        // Ocultar loading
        this.ddlLoading = false;
      }
    },
    async cargarArchivoWord(path) {
      // Mostrar loading
      this.ddlLoading = true;

      this.datosItemDictamen.pathPdf = path;

      try {
        const res = await Vue.axios.put(
          `${this.url}/api/GenerarDocumento/updateResolucionAMI`,
          this.datosItemDictamen
        );

        if (res.data.status === 200) {
          this.solicitud = res.data.data;
          this.$refs.snackalert.SnackbarShow(
            "success",
            "Alerta",
            res.data.message
          );
          this.dialogCrearDictamen = false;
          this.obtenerItemsA();
          this.obtenerItemsB1();
          this.obtenerItemsB2();
        } else {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            res.data.message ||
              "Ocurrió un problema al actualizar la resolución."
          );
        }
      } catch (error) {
        if (error.response && error.response.status === 500) {
          this.$refs.snackalert.SnackbarShow(
            "error",
            "Error",
            "Ocurrió un error en el servidor, intente nuevamente."
          );
        } else {
          this.$refs.snackalert.SnackbarShow(
            "error",
            "Error",
            "Ocurrió un error inesperado al actualizar la resolución."
          );
        }
      } finally {
        // Asegúrate de ocultar el loading
        this.ddlLoading = false;
      }
    },
    descargarPlantillaWord(Id, tipo) {
      this.dialogLoaderVisible = true;
      this.$store
        .dispatch(OBTENER_PATH_RESOLUCION_PLANTILLA, {
          expedienteId: Id,
          tipo: tipo,
        })
        .then((res) => {
          if (res.status === 200) {
            this.descargarArchivoBackend(res.message);
            this.obtenerExpedienteDictamenes(this.expedienteId);
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
          this.dialogLoaderVisible = false;
          //console.log(this.items);
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
        });
    },
    descargarArchivoBackend(path) {
      let newPath = path.replace(/\\/g, "/");
      //server
      window.open("http://preprod-wsayb.marn.gob.gt" + newPath, "_blank");
      //local
      //window.open("http://10.4.1.51:8080" + newPath, "_blank");
    },
    descargarArchivo(path) {
      let newPath = path.replace(/\\/g, "/");
      //console.log(newPath);

      //SERVIDOR_PREPRODUCCION
      window.open("http://preprod-interface.marn.gob.gt" + newPath, "_blank");

      //LOCAL
      //window.open("http://10.4.1.51:8080" + newPath, "_blank");
    },
    // Tipo: 1 REquisito, 2 TDR
    mostrarModalCargaDocumento(id) {
      //console.log(nombre);
      this.datosItemDictamen.expedienteId = id;
      //this.tipoRequisitoId = tipo;
      //this.documentoSeleccionado = documento;
      this.dialogCargaDocumento = true;
      //this.datosRequisitoExpediente.asigAcuerdoRequisitosId = asigAcuerdoRequisitosId;
    },
    async asignarParaFirma() {
      this.datosExpediente.usuario = JwtService.getUser();
      this.datosExpediente.id_Expediente = this.expedienteId;
      this.datosExpediente.estado_Id = 14;

      await this.$store
        .dispatch(CAMBIAR_ESTADO_EXPEDIENTE_RESOLUCION, this.datosExpediente)
        .then((res) => {
          this.btnLoading = false;
          //this.dialogLoaderVisible = false;
          if (res.status === 200) {
            this.$refs.snackalert.SnackbarShow(
              "success",
              "Mensaje",
              res.message
            );
            this.dialogLoaderVisible = false;
            this.obtenerItemsB2();
            this.obtenerItemsB1();
            this.obtenerItemsA();
            this.dialogResolucion = false;
          } else {
            this.$refs.snackalert.SnackbarShow(
              "warning",
              "Alerta",
              res.message
            );
          }
        })
        .catch(() => {
          this.dialogLoaderVisible = false;
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            // eslint-disable-next-line
                `Ha ocurrido un al eliminar el registro.`
          );
        });
    },
    onFileChange(e) {
      if (e) {
        let fileName = e.name;
        let fileNameWithoutExtension = fileName.substring(
          0,
          fileName.lastIndexOf(" ")
        );
        if (fileNameWithoutExtension === "") {
          fileNameWithoutExtension = fileName.substring(
            0,
            fileName.lastIndexOf(".")
          );
        }
        //! Validar que el tipo de archivo sea PDF
        if (e.type !== "application/pdf") {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `El archivo que desea ingresar no es un PDF.`
          );
          document.querySelector("#docFile").value = "";
          this.$refs.docFile.reset();
          return false;
        }
        //?Validar que el tamaó del archivo no exceda los 10Mb
        if (e.size / 1024 / 1024 > 10) {
          this.$refs.snackalert.SnackbarShow(
            "warning",
            "Alerta",
            `El tamaño del archivo excede el límite permitido (10Mb)`
          );
          // this.$refs.file.reset();
          document.querySelector("#docFile").value = "";
          this.$refs.docFile.reset();
          return false;
        }

        this.archivo = e;
      }
    },
    async cargarArchivo() {
      // Mostrar loading
      this.dialogLoaderVisible = true;
      this.btnCargaDocLoading = true;

      const files = this.archivo;
      let path = `\\ResolucionExpedienteAMI\\expedientes\\${this.datosItemDictamen.expedienteId}\\procurador\\`;

      try {
        const res = await this.$store.dispatch(CARGAR_ARCHIVO, {
          file: files,
          path: path,
        });

        if (res.status === 200) {
          this.archivoCargado = true;
          this.cargarArchivoWord(res.pathArchivo);
          this.$refs.docFile.reset();
          document.querySelector("#docFile").value = "";
          this.$refs.snackalert.SnackbarShow(
            "success",
            "Alerta",
            "Archivo cargado exitosamente."
          );
          this.dialogCargaDocumento = false;
          this.obtenerItemsA();
          this.obtenerItemsB1();
          this.obtenerItemsB2();
        } else {
          this.archivoCargado = false;
          this.$refs.snackalert.SnackbarShow("warning", "Alerta", res.mensaje);
        }
      } catch (error) {
        if (error.response && error.response.status === 500) {
          this.$refs.snackalert.SnackbarShow(
            "error",
            "Error",
            "Ocurrió un error en el servidor, intente nuevamente."
          );
        } else {
          this.$refs.snackalert.SnackbarShow(
            "error",
            "Error",
            "Ocurrió un error inesperado al cargar el archivo."
          );
        }
        this.archivoCargado = false;
      } finally {
        // Ocultar loading
        this.dialogLoaderVisible = false;
        this.btnCargaDocLoading = false;
      }
    },
  },
  created() {
    this.obtenerItemsB2();
    this.obtenerItemsB1();
    this.obtenerItemsA();
    //this.obtenerSolicitudes();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Inicio", route: "/dashboard" },
      { title: "Procurador" },
    ]);
  },
  computed: {
    modal() {
      return modal;
    },
    // currentUser: {
    //   get() {
    //     return this.$store.state.auth.user;
    //   },
    // },
    headers() {
      return [
        {
          text: "Track Id",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "No. Expediente",
          align: "start",
          sortable: false,
          value: "no_Expediente",
        },
        {
          text: "Nombre del proyecto",
          align: "start",
          sortable: true,
          value: "nombre_Proyecto",
        },
        // {
        //   text: "Desripción del proyecto",
        //   align: "start",
        //   sortable: true,
        //   value: "descripcion_Proyecto",
        // },
        {
          text: "Estado",
          align: "start",
          sortable: true,
          value: "estadoExpediente",
          filter: this.filtroEstado,
        },
        {
          text: "Acciones",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
    headerDictamen() {
      return [
        {
          text: "Resolución",
          align: "start",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Fecha Ingreso",
          align: "start",
          sortable: false,
          value: "fecha_Creacion",
        },
        {
          text: "Usuario Ingreso",
          align: "start",
          sortable: false,
          value: "usuario_Creacion",
        },
        {
          text: "Dictamen",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Plantilla Word",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Cargar Resolución",
          align: "start",
          sortable: false,
          value: "",
        },
        {
          text: "Documento",
          align: "start",
          sortable: false,
          value: "",
        },
      ];
    },
  },
};
</script>
